import React from 'react';
import _PhotoGallery from '../components/_PhotoGallery';
import MainLayout from '../layout/MainLayout';

const PhotoGalleryPage = () => {
  return (
    <MainLayout>
        <_PhotoGallery/>
    </MainLayout>
  )
}

export default PhotoGalleryPage